import { api } from './client';
import {
  PodcastFeed,
  PodcastFeedListResponse,
} from '../types';

export interface CreatePodcastFeedRequest {
  name: string;
  description?: string;
  conversionIds?: string[];
  published?: boolean;
}

export interface UpdatePodcastFeedRequest {
  name?: string;
  description?: string | null;
  published?: boolean;
}

export const podcastFeedsApi = {
  list: (): Promise<PodcastFeedListResponse> =>
    api.get<PodcastFeedListResponse>('/v1/podcast-feeds/'),

  create: (request: CreatePodcastFeedRequest): Promise<PodcastFeed> =>
    api.post<PodcastFeed>('/v1/podcast-feeds/', request),

  get: (feedId: string): Promise<PodcastFeed> =>
    api.get<PodcastFeed>(`/v1/podcast-feeds/${feedId}`),

  update: (
    feedId: string,
    request: UpdatePodcastFeedRequest
  ): Promise<PodcastFeed> =>
    api.patch<PodcastFeed>(`/v1/podcast-feeds/${feedId}`, request),

  remove: (feedId: string): Promise<void> =>
    api.delete<void>(`/v1/podcast-feeds/${feedId}`),

  addItems: (feedId: string, conversionIds: string[]): Promise<PodcastFeed> =>
    api.post<PodcastFeed>(`/v1/podcast-feeds/${feedId}/items`, {
      conversionIds,
    }),

  removeItem: (feedId: string, conversionId: string): Promise<PodcastFeed> =>
    api.delete<PodcastFeed>(
      `/v1/podcast-feeds/${feedId}/items/${conversionId}`
    ),

  reorder: (
    feedId: string,
    conversionIds: string[]
  ): Promise<PodcastFeed> =>
    api.put<PodcastFeed>(`/v1/podcast-feeds/${feedId}/items/order`, {
      conversionIds,
    }),
};

export default podcastFeedsApi;
